<h2>{{ componentTitle }}</h2>
<p-table #dt2 [value]="vehicles" [columns]="cols" [lazy]="true" (onLazyLoad)="loadVehiclesLazy($event)" [paginator]="true"
         [rows]="10" [totalRecords]="totalRecords" styleClass="mvd_table--notfixed">
    <ng-template pTemplate="caption" *ngIf="filterEnabled">
        <div class="row">
            <div class="col-sm-6 col-md-3">
                <input class="mvd_form-control" type="text" pInputText size="50" placeholder="Filter Results..." [(ngModel)]="filterText" (input)="dt2.filterGlobal($event.target.value,'contains')">
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
        <tr>
            <th *ngFor="let col of columns">
                {{col.header}}
            </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-item>
        <tr>
            <td *ngFor="let col of cols">
                <ng-container [ngSwitch]="col.header">
                    <ng-container *ngSwitchCase="'VIN'">
                        <a (click)="emitVehicleSelection(item.vehicleId)" href="javascript:void(0);" *ngIf="!hideActions">{{item[col.field]}}</a>
                        <ng-container *ngIf="hideActions">{{item[col.field]}}</ng-container>
                    </ng-container>
                    <ng-container *ngSwitchCase="'Plate Type'">
                        <ng-container *ngIf="item[col.field] && plateType.FromId(item[col.field])">
                            {{plateType.FromId(item[col.field]).displayValue}}
                        </ng-container>
                    </ng-container>
                    <ng-container *ngSwitchCase="'Reg Exp'">{{item[col.field] | shortDate}}</ng-container>
                    <ng-container *ngSwitchCase="'Fleet Exp'">{{item[col.field] | shortDate}}</ng-container>
                    <ng-container *ngSwitchCase="'Ownership From'">{{item[col.field] | shortDate}}</ng-container>
                    <ng-container *ngSwitchCase="'Ownership To'">{{item[col.field] | shortDate}}</ng-container>
                    <ng-container *ngSwitchCase="'Indicator'">
                        <a href="javascript:void(0)" title="Emissions" *ngIf="emissionDue(item.vehicleId)"><i class="material-icons">cloud_circle</i></a>
                        <a href="javascript:void(0)" title="Withdrawl" *ngIf="withdrawlExists(item.vehicleId)"><i class="material-icons">unarchive</i></a>
                        <a href="javascript:void(0)" title="Sold Notice" *ngIf="soldNoticeExists(item.vehicleId)"><i class="material-icons">sell</i></a>
                        <a href="javascript:void(0)" title="Cannot Be Evaluated" class="icon--failed" *ngIf="hasError(item.vehicleId)"></a>
                    </ng-container>
                    <ng-container *ngSwitchDefault>{{item[col.field]}}</ng-container>
                </ng-container>
            </td>
        </tr>
    </ng-template>
</p-table>
